import { render, staticRenderFns } from "./DetailedView.vue?vue&type=template&id=ecebf980&scoped=true&"
import script from "./DetailedView.vue?vue&type=script&lang=js&"
export * from "./DetailedView.vue?vue&type=script&lang=js&"
import style0 from "./DetailedView.vue?vue&type=style&index=0&id=ecebf980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecebf980",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QToggle,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QToggle,QBtn})
